// add / remove blur class from body
export const handleGlobalBlurClass = () => {
  const isBlur = localStorage.getItem("isBlur");
  if (isBlur) {
    document.body.classList.add("is-blur");
  } else {
    document.body.classList.remove("is-blur");
  }
};

export const toggleBlur = (e) => {

  // check if element clicked is the username to stop it
  if (e.target.dataset.user !== undefined) return false;

  const bodyIsBlur = document.querySelector("body.is-blur");
  if (!bodyIsBlur) return;

  // Get element blur filter
  const elBlurred = window
    .getComputedStyle(e.target)
    .getPropertyValue("filter")
    .includes("blur");
  // Check if element is inside of any highcharts
  const elBlurredInsideHighchart = [...e.target.classList].some(cl =>
    cl.startsWith("highcharts")
  );
  const isWealthMap = e.target.closest(".wealth-map__wrapper");

  if (elBlurredInsideHighchart) {
    // If element is inside of highchart, toggle chart's blur
    if (e.target.closest(".c-charts"))
      e.target.closest(".c-charts").classList.toggle("no-blur");
    if (e.target.closest(".wrapper-barsGraphic"))
      e.target.closest(".wrapper-barsGraphic").classList.toggle("no-blur");
  } else if (isWealthMap) {
    isWealthMap.classList.toggle("no-blur");
  } else {
    // if (!elBlurred) return;
    // Toggle blur on element
    elBlurred && e.target.classList.toggle("no-blur");
  }
};

// Show / hide blur class from any element with a timer
export const hideShowBlurTimer = ({ counter = 0, limit = 10, target, start, complete }) => {
  if (!target) return;

  if (start) start();

  // activate timer
  const interval = setInterval(() => {
    if (counter >= limit) {
      //stop counter and reset blur
      clearInterval(interval);
      counter = 0;
      target.classList.remove("no-blur");
      if (complete) complete();
    } else {
      counter++;
    }
  }, 1000);
};
